import { useEffect } from 'react'

const FLASH_INTERVAL_MS = 1_200

// Alternates the tab title while count is above zero, so a background tab shows
// there is something waiting.
export const useTitleFlash = (count: number, label: string) => {
  useEffect(() => {
    if (count < 1) return

    const alertTitle = `(${count}) ${label}`
    let baseTitle = document.title

    // Only ever restore a title we replaced. Anything else on screen is what
    // useRouteTitle wants there now, so adopt it as the new base.
    const timer = setInterval(() => {
      if (document.title === alertTitle) {
        document.title = baseTitle
      } else {
        baseTitle = document.title
        document.title = alertTitle
      }
    }, FLASH_INTERVAL_MS)

    return () => {
      clearInterval(timer)
      if (document.title === alertTitle) document.title = baseTitle
    }
  }, [count, label])
}
